import React from "react";
import { useJourney } from "./sign_up_journeys";

const Field = ({ name, value }) => {
  return (
    <div>
      <div className="text-xs font-bold">{name}</div>
      <div>{value}</div>
    </div>
  );
};
const Summary = () => {
  const { journey } = useJourney();

  return (
    <div className="h-full w-full min-h-screen bg-gradient-to-br from-posboss-brand-gradient-blue to-paperless-brand-gradient-green p-64">
      <div className="p-32 space-y-32  rounded bg-white shadow max-w-screen-sm mx-auto">
        <h1>
          {journey.firstName}'s from {journey.venueName}
        </h1>
        <div className="space-y-12">
          <h2>Personal Info</h2>
          <div className="grid gap-12 grid-cols-2">
            <Field
              name={"Name"}
              value={`${journey.firstName} ${journey.lastName}`}
            />
            <Field name={"Email"} value={journey.email} />
            <Field name={"Role"} value={journey.role} />
            <Field
              name={"Location"}
              value={`${journey.countryCode} > ${journey.subcountry} > ${journey.city}`}
            />
          </div>
        </div>
        <div className="space-y-12">
          <h2>Venue Info</h2>
          <div className="grid gap-12 grid-cols-2">
            <Field name={"Venue Name"} value={journey.venueName} />
            <Field name={"Style of Business"} value={journey.styleOfBusiness} />
            <Field name={"Venue Status"} value={journey.venueStatus} />
            <Field
              name={"Name"}
              value={`${journey.firstName} ${journey.lastName}`}
            />
          </div>
        </div>
        <div className="space-y-12">
          <h2>The rest</h2>
          <div className="grid gap-12 grid-cols-2">
            <Field
              name={"Biggest Challenge"}
              value={journey.biggestChallenge}
            />
            <Field
              name={"Further Questions"}
              value={journey.furtherQuestions}
            />
            <Field name={"Go Live Date"} value={journey.goLiveDate} />
            <Field name={"Hardware Help"} value={journey.hardwareHelp} />
            <Field
              name={"Wants Partner Contact"}
              value={journey.partnerContact}
            />
            <Field
              name={"Wants to talk someone"}
              value={journey.talkToSomeone}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Summary;
